import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  height: 56px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 10px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img``;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-items: center;
  background: #231f19;
  display: flex;
  height: 56px;
  justify-content: center;
  margin-right: 12px;
  width: 56px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  color: #80A8AF;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  line-height: 56px;
  padding: 0 18px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 40px;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  height: 56px;
  width: 8px;
`;
Space.displayName = 'Space';

export const TeamContainer = styled.div`
  background-color: #231f19;
  display: flex;
  height: 56px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamName = styled.div`
  color: #ffffff;
  display: flex;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  justify-content: center;
  letter-spacing: 0px;
  line-height: 56px;
  min-width: calc(128px - 32px);
  padding: 0 16px;
`;
TeamName.displayName = 'TeamName';

export const TeamNameSpace = styled.div`
  height: 56px;
  width: 20px;
`;
TeamNameSpace.displayName = 'TeamNameSpace';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #D2CECD;
  display: flex;
  height: 56px;
  justify-content: center;
  margin-left: 8px;
  min-width: 178px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #231F19;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 56px;
  text-align: center;
`;
Timer.displayName = 'Timer';
